import { HttpClient, ListParams } from './http-client';

export class ReportJournalService extends HttpClient {
  mineralFertilizerXlsx(farmId: string, params: ListParams) {
    return this.export(
      `/api/farms/${farmId}/report-journals/mineral-fertilizers`,
      params
    );
  }

  plantProtectionProductsXlsx(farmId: string, params: ListParams) {
    return this.export(
      `/api/farms/${farmId}/report-journals/plant-protection-products`,
      params
    );
  }

  manureXlsx(farmId: string, params: ListParams) {
    return this.export(`/api/farms/${farmId}/report-journals/manure`, params);
  }

  biocideXlsx(farmId: string, params: ListParams) {
    return this.export(`/api/farms/${farmId}/report-journals/biocides`, params);
  }

  veterinaryMedicationXlsx(farmId: string, params: ListParams) {
    return this.export(
      `/api/farms/${farmId}/report-journals/veterinary-medication`,
      params
    );
  }
  milkAccountingXlsx(farmId: string, params: ListParams) {
    return this.export(
      `/api/farms/${farmId}/report-journals/milk-accounting`,
      params
    );
  }
}
